<template>
    <div class="layer-content common"
         style="padding:0;max-height: 600px"
         v-if="showAt">
        <template v-if="mode == 'SEL'">
            <table class="tb-row" style="width : 100%;">
                <colgroup>
                    <col style="width: 150px;">
                    <col>
                </colgroup>
                <tbody>
                <tr>
                    <th class="__left">납부처리방법</th>
                    <td>
                        <template v-for="(payMeanInfo,index) in payMeanList">
                            <input type="radio"
                                   name="payMean"
                                   :key="'payMeanIp' + payMeanInfo.cd"
                                   :id="'payMean' + payMeanInfo.cd"
                                   v-model="selPayMean"
                                   :value="payMeanInfo.cd"/>
                            <label :class="index == 0?'mgl0':'mgl10'"
                                   :key="'payMeanLb' + payMeanInfo.cd"
                                   :for="'payMean' + payMeanInfo.cd">
                                <span class="box"></span>
                                <span class="label-txt">&nbsp;{{payMeanInfo.cdNm}}</span>
                            </label>
                        </template>
                    </td>
                </tr>
                <tr>
                    <th class="__left">설명</th>
                    <td>
                        <template v-for="(explanHtml,index) in selPayMenInfo.explanList">
                            <span :key="'explanInfo' + index"
                                  v-html="explanHtml"></span>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="btn-wrap center"
                 style="height: 62px; padding: 15px 0;">
                <button class="big _bt-white"
                        @click="closePopup()">
                    <span>취소</span>
                </button>
                <button class="big _bt-navy"
                        @click="btn_payClick()">
                    <span>결제하기</span>
                </button>
            </div>
        </template>
        <template v-if="mode == 'MULTIPAY'">
            <table class="tb-row" style="width : 100%;">
                <colgroup>
                    <col style="width: 150px;">
                    <col>
                </colgroup>
                <tbody>
                <tr>
                    <th class="__left">리더기</th>
                    <td>
                        총 {{this.priceInfo.detectorCnt}}대, 결제 금액 : {{this.priceInfo.detectorCalTotPrice}}원
                        <template v-if="priceInfo.detectorPayAt"> - 결제완료</template>
                        <button class="small _bt-blue"
                                style="height: 20px;line-height: 20px;"
                                v-if="!priceInfo.detectorPayAt"
                                @click="btn_pay002Click('DETECTOR')">
                            <span>결제하기</span>
                        </button>
                    </td>
                </tr>
                <tr>
                    <th class="__left">태그</th>
                    <td>
                        총 {{this.priceInfo.tagCnt}}개, 결제 금액 : {{this.priceInfo.tagTotPrice}}원
                        <template v-if="priceInfo.tagPayAt"> - 결제완료</template>
                        <button class="small _bt-blue"
                                style="height: 20px;line-height: 20px;"
                                v-if="!priceInfo.tagPayAt"
                                @click="btn_pay002Click('TAG')">
                            <span>결제하기</span>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="btn-wrap center"
                 style="height: 62px; padding: 15px 0;">
                <button class="big _bt-white"
                        @click="closePopup()">
                    <span>취소</span>
                </button>
                <!--<button class="big _bt-navy"
                        @click="btn_backClick()">
                    <span>이전</span>
                </button>-->
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'selPayMeanPopup',
        props: ['param', 'index'],
        data: function(){
            return {
                showAt: false,
                mode: 'SEL',
                selPayMean: '001',
                callBackFunc   : null,
                payMeanList: [
                    {
                        cd:'001',
                        cdNm:'일괄결제',
                        explanList: [
                            '<div>※ 리더기, 태그를 일괄로 결제 하실 수 있습니다.</div>',
                            '<div style="padding-top: 5px;">※ 예시</div>',
                            '<div style="padding-left: 15px;padding-top: 3px;">a.결제( 일괄결제 )</div>',
                            '<div style="padding-left: 30px;padding-top: 3px;">- 300,000원(리더기 1대) + 100,000원(태그 20개) = 400,000원</div>',
                            '<div style="padding-left: 15px;padding-top: 3px;">b.카드영수증( 일괄출력 )</div>',
                            '<div style="padding-left: 30px;padding-top: 3px;">- 400,000원(리더기 1대 + 태그 20개)</div>',
                        ]
                    },
                    {
                        cd:'002',
                        cdNm:'분할결제',
                        explanList: [
                            '<div>※ 리더기, 태그를 분할하여 결제 하실 수 있습니다.</div>',
                            '<div style="padding-top: 5px;">※ 예시</div>',
                            '<div style="padding-left: 15px;padding-top: 3px;">a.결제( 분할결제 )</div>',
                            '<div style="padding-left: 30px;padding-top: 3px;">- 300,000원(리더기 1대) = 300,000원</div>',
                            '<div style="padding-left: 30px;padding-top: 3px;">- 100,000원(태그 20개) = 100,000원</div>',
                            '<div style="padding-left: 15px;padding-top: 3px;">b. 카드영수증( 분할출력 )</div>',
                            '<div style="padding-left: 30px;padding-top: 3px;">- 300,000원(리더기 1대)</div>',
                            '<div style="padding-left: 30px;padding-top: 3px;">- 100,000원(태그 20개)</div>',
                        ]
                    },
                ],
                priceInfo: null
            }
        },
        computed: {
            selPayMenInfo: function(){
                const _this = this;
                return this.payMeanList.find(function(info){
                    return info.cd == _this.selPayMean;
                })
            }
        },
        methods: {
            btn_payClick: function(){
                if(this.selPayMean == '001'){
                    this.param.cardPayProcFunc(this.param.orderInfo,'ALL',this.payCallback);
                }else if(this.selPayMean == '002'){
                    let priceInfo = this.param.calOrderPriceInfoFunc(this.param.orderInfo);
                    priceInfo.detectorPayAt = false;
                    priceInfo.tagPayAt = false;
                    this.priceInfo = priceInfo;
                    this.mode = 'MULTIPAY'
                }

            },
            btn_backClick: function(){
                this.mode = 'SEL'
            },
            btn_pay002Click: function(orderPaySe){
                this.param.cardPayProcFunc(this.param.orderInfo,orderPaySe,this.payCallback);
            },
            payCallback: function(procInfo){
                this.param.cardPayCallbackFunc(procInfo,this.procCallback);
            },
            procCallback: function(orderPaySe){
                if(orderPaySe == 'ALL'){
                    this.closePopup();
                }else{
                    if(orderPaySe == 'DETECTOR') this.priceInfo.detectorPayAt = true;
                    else if(orderPaySe == 'TAG') this.priceInfo.tagPayAt = true;

                    if(this.priceInfo.detectorPayAt&&this.priceInfo.tagPayAt){
                        this.closePopup();
                    }
                }

            },
            closePopup : function(){
                this.$store.commit('closePopup', this.index);
            }
        },
        mounted: function() {
            console.log(this.param.orderInfo);
            this.showAt = true;
        }
    }
</script>

<style scoped>

</style>